import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ElevatedAuditApproverSchema = withDefaults({
  type: 'elevated-audit-approver',
  fields: [
    {
      kind: 'attribute',
      name: 'personId',
    },
    {
      kind: 'attribute',
      name: 'personName',
    },
    {
      kind: 'attribute',
      name: 'auditPct',
    },
    {
      kind: 'attribute',
      name: 'flaggedByName',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
  ],
});

export default ElevatedAuditApproverSchema;
